import { createAction } from 'redux-actions'

const prefix = 'SURVEY/'

export const submitSurveyStart = createAction(`${prefix}SUBMIT_SURVEY_START`)
export const submitSurveySuccess = createAction(`${prefix}SUBMIT_SURVEY_SUCCESS`)
export const submitSurveyError = createAction(`${prefix}SUBMIT_SURVEY_ERROR`)
